import { render, staticRenderFns } from "./explo-liuqiu.vue?vue&type=template&id=27160084&"
import script from "./explo-liuqiu.vue?vue&type=script&lang=js&"
export * from "./explo-liuqiu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports